import script from "./DetailsLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsLayout.vue?vue&type=script&setup=true&lang=js"

import "./DetailsLayout.vue?vue&type=style&index=0&id=950eb790&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-950eb790"]])

export default __exports__